export default {"src":"/_next/static/media/arrowDown.dccaf776.svg","height":24,"width":24};